(() => {
  const initCoffeeMomentMotion = (root = document) => {
    document.documentElement.classList.add('cm-motion-enabled');

    const revealItems = root.querySelectorAll ? root.querySelectorAll('.cm-reveal:not([data-cm-motion-ready])') : [];
    if (!('IntersectionObserver' in window)) {
      revealItems.forEach((el) => el.classList.add('cm-visible'));
    } else {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('cm-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
      revealItems.forEach((el) => {
        el.dataset.cmMotionReady = 'true';
        observer.observe(el);
      });
    }

    const productInfo = root.querySelector ? root.querySelector("main[data-template='product'] .product__info-container") : null;
    if (productInfo && !productInfo.dataset.cmHeroMotion) {
      productInfo.dataset.cmHeroMotion = 'true';
      [...productInfo.children].forEach((child, index) => {
        child.classList.add('cm-hero-item');
        child.style.setProperty('--cm-order', Math.min(index, 10));
      });
    }

    root.querySelectorAll?.('[data-cm-scroll-buy]:not([data-cm-scroll-ready])').forEach((button) => {
      button.dataset.cmScrollReady = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const target = document.querySelector("main[data-template='product'] .product-form, main[data-template='product'] variant-selects");
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCoffeeMomentMotion());
  else initCoffeeMomentMotion();

  document.addEventListener('shopify:section:load', (event) => initCoffeeMomentMotion(event.target));
})();
